import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDirectorChair: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDirectorChair"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V11H22V12.5H19.4732L13.3679 16.5L20.2877 21.0337L19.4656 22.2884L11.9993 17.3967L4.53298 22.2884L3.71094 21.0337L10.6308 16.5L4.52544 12.5H2V11H4V2ZM7.26253 12.5L11.9993 15.6034L16.7361 12.5H7.26253Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDirectorChair;
